/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Attribute_Purchase_DescriptionInputs */

const en_attribute_purchase_description = /** @type {(inputs: Attribute_Purchase_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Purchase description`)
};

/**
* | output |
* | --- |
* | "Purchase description" |
*
* @param {Attribute_Purchase_DescriptionInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const attribute_purchase_description = /** @type {((inputs?: Attribute_Purchase_DescriptionInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Attribute_Purchase_DescriptionInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_attribute_purchase_description(inputs)
});